export default "__VITE_ASSET__DDg121yU__"